import { render, staticRenderFns } from "./PrintReceiptIndex.vue?vue&type=template&id=3cb6c7f6&"
import script from "./PrintReceiptIndex.vue?vue&type=script&lang=js&"
export * from "./PrintReceiptIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports